import { useEffect } from 'react';
import { useRequest } from '@fuxi/eevee-hooks';
import { MonorepoType, useLoginInfo } from '@yaotai/common-utils';

import { CommonAPI } from '../services';

export type SpaceCheckOptions = {
  isDingzhiWithSpace?: boolean; // 是需要企业空间的定制版本
  isMainVersion?: boolean; // 是主线版本
  monorepoType?: MonorepoType;
};

export function useSpaceCheck({
  isMainVersion = true,
  isDingzhiWithSpace = false,
  monorepoType,
}: SpaceCheckOptions = {}) {
  const { hasUserInfo } = useLoginInfo();
  const { data, loading, run } = useRequest(
    () => {
      return CommonAPI.current!?.space.checkSpacePermission();
    },
    { manual: true },
  );

  useEffect(() => {
    if (isMainVersion || import.meta.env.VITE_NEED_CORPORATOR === 'true') {
      if (hasUserInfo && ['portal', 'center', 'corporate'].includes(monorepoType || '')) {
        run();
      }
    }
  }, [hasUserInfo, isMainVersion, monorepoType, run]);

  return {
    hasSpacePermission: isMainVersion || isDingzhiWithSpace ? !!data?.data?.result : false,
    isCheckingSpacePermission: loading,
  };
}
